import type { PolicyActionModel } from '../../../types';
import type { PolicyAction } from './policy-schema';

export function formatPolicyScheduleTime(time: string | number): string {
  let hour: number;
  let minute = 0;

  if (typeof time === 'number') {
    hour = time;
  } else {
    const parts = String(time).split(':');
    hour = Number.parseInt(parts[0], 10);
    minute = parts.length > 1 ? Number.parseInt(parts[1], 10) : 0;
  }

  if (Number.isNaN(hour)) {
    return String(time);
  }

  const minuteSuffix = minute > 0 ? `:${String(minute).padStart(2, '0')}` : '';

  if (hour === 0) return `12${minuteSuffix} AM`;
  if (hour < 12) return `${hour}${minuteSuffix} AM`;
  if (hour === 12) return `12${minuteSuffix} PM`;
  return `${hour - 12}${minuteSuffix} PM`;
}

export function formatPolicyScheduleTimes(
  times: Array<string | number>
): string[] {
  return times.map(formatPolicyScheduleTime);
}

export function transformActionHash(actionHash: {
  [key: string]: PolicyActionModel;
}): PolicyAction[] {
  return Object.keys(actionHash)
    .map((key) => {
      const action = actionHash[key];

      if (!action) return null;

      if (key === 'Create_Gmail_Filter') {
        return {
          type: key,
          gmailFilter: action.gmailFilter ?? null,
          ...(action.actionData ?? {}),
        } as PolicyAction;
      } else if (key === 'Set_Profile_Information') {
        return {
          type: key,
          userModelTemplate: action.userModelTemplate ?? {},
          ...(action.actionData ?? {}),
        } as PolicyAction;
      } else {
        return {
          type: key,
          ...(action.actionData ?? {}),
        } as PolicyAction;
      }
    })
    .filter((item): item is PolicyAction => item !== null);
}
